import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const IntegrationInstanceCard = styled(Box)<{ isFailed?: boolean }>`
  display: flex;
  align-items: center;
  background: ${theme.colors.settingsCardBg};
  border-radius: ${theme.attributes.borderRadius.tertiary};
  padding: ${theme.spacing.half}px ${theme.spacing.small}px ${theme.spacing.half}px ${theme.spacing.half}px;
  height: 52px;
  width: 100%;

  html[data-theme='light'] & {
    background: #fafafb;
    border: 1px solid ${theme.colors.strokePrimary};
    box-shadow: none;

    &:hover {
      background: ${theme.colors.menuItemHover};
    }
  }

  img {
    object-fit: cover;
    min-width: 44px;
    border-radius: ${theme.spacing.xSmall}px;
  }

  .MuiTypography-root {
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.bold};
    font-size: ${theme.typography.fontSize.large};
    line-height: 20px;
    letter-spacing: 0.1px;
    color: ${theme.colors.menuItemText};
    margin-left: ${theme.spacing.xSmall}px;
    word-break: break-all;
  }

  &:hover {
    background: ${theme.colors.tooltipBg};
  }

  .MuiCheckbox-root svg {
    rect {
      stroke: ${theme.colors.checkboxUnchecked};
    }

    path {
      stroke: ${theme.colors.checkboxChecked};
    }
  }
`

export const IntegrationTextItem = styled(Box)<{ active: boolean }>`
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  .MuiTypography-root {
    word-break: break-word;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large} !important;
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 20px;
    color: ${theme.colors.foreground} !important;
  }

  .box-wrapper {
    display: flex;
    align-items: center;
    gap: ${theme.spacing.xsm}px;
    margin-left: ${theme.spacing.xSmall}px;

    .text {
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.medium} !important;
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 16px;
      margin-left: 0 !important;
      color: ${theme.colors.legacyControlBorder2} !important;

      ${({ active }) =>
        active &&
        `
        color: ${theme.colors.statusValueGood} !important;
      `};
    }
  }
`
